import { UserCheck, UserPlus, UsersIcon, UserX } from "lucide-react";
import { motion } from "framer-motion";

import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../apiConfig";


import Header from "../Components/Common/Header";
import StatCard from "../Components/Common/StatCard";
import UserGrowthChart from "../Components/Admin/UserGrowthChart";
import UserActivityHeatmap from "../Components/Admin/UserActivityHeatMap"


import"../Styles/Admin/UserPage.css"


const UsersPage = () => {

	const [stats, setStats] = useState({
		totalUsers: 0,
		newUsersToday: 0,
		activeUsers: 0,
		churnRate: "0.0",
	  });


	  useEffect(() => {
		const fetchUserStats = async () => {
		  try {
			const response = await fetch(`${API_BASE_URL}/admin/user-stats`, {
			  method: "GET",
			  headers: {
				Authorization: `Bearer ${localStorage.getItem("idToken")}`,
			  },
			});
			  if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          window.location.href = '/';
          return;
        }
			const data = await response.json();
			if (data.success) {
			  setStats(data.stats);
			} else {
			  console.error("Failed to fetch user stats:", data.message);
			}
		  } catch (err) {
			console.error("Error fetching user stats:", err);
		  }
		};
		
			fetchUserStats();
			
		  }, []);
	return (
		<div className="users-page-container">
			<div className="ap-wrap-content">
				<Header 
  title="Users Management" 
  description="Monitor and manage user accounts and activities" 
  icon={<UsersIcon size={28} color="#f3f4f6"/>}
/>


			<main className="users-main">
				{/* STATS */}
				<motion.div
					className="users-stats-grid"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 1 }}
				>
					 <StatCard
            name="Total Users"
            icon={UsersIcon}
            value={stats.totalUsers}
            color="#6366F1"
          />
          <StatCard
            name="New Users Today"
            icon={UserPlus}
            value={stats.newUsersToday}
            color="#10B981"
          />
          <StatCard
            name="Active Users"
            icon={UserCheck}
            value={stats.activeUsers}
            color="#F59E0B"
          />
          <StatCard
            name="Churn Rate"
            icon={UserX}
            value={`${stats.churnRate}%`}
            color="#EF4444"/>
				</motion.div>

				{/* USER CHARTS */}
				<div className="users-charts-grid">
					<UserGrowthChart />
					<UserActivityHeatmap />
					
				</div>
			</main>
			</div>
		
		</div>
	);
};

export default UsersPage;
